// Module
var code = `<div class="footer-modify-position-screen">
    <terceraButton name="modifyBtn" text="{{.modifyBtnText}}" terceraButtonStyle="js-button-ok" on-btnClick="@this.modify()" />
    <terceraButton name="cancelBtn" text="{{.cancelBtnText}}" terceraButtonStyle="js-button-gray25" on-btnClick="@this.closeScreen()" />
</div>`;
// Exports
export default code;